module.exports = __webpack_public_path__ + "img/ico-web.c07a9841.svg";